// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2024331a52578c2c1c5d","655":"862985946fdafaeca7aa"}[chunkId] + ".js";
};